<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    d="M19 12H11C8.79086 12 7 13.7909 7 16V36C7 38.2091 8.79086 40 11 40H31C33.2091 40 35 38.2091 35 36V28M27 8H39M39 8V20M39 8L19 28"
    stroke="currentColor"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
